import { ApiException } from '@eta/components';
import {
    CheckDelegationInvitationValidityQueryResponse,
    CreateUserProfileDto,
    AccetpInvitationDto,
} from '../../Services/ClientProxy/clientProxy';

export const LOAD_CURRENT_INVITATION = 'LOAD_CURRENT_INVITATION';
export const COMPLETE_PROFILE = 'COMPLETE_PROFILE';
export const ACCEPT_INVITATION = 'ACCEPT_INVITATION';

export interface LoadCurrentInvitationAction {
    type: typeof LOAD_CURRENT_INVITATION;
    payload: CheckDelegationInvitationValidityQueryResponse | ApiException;
}

export interface CompletetProfileAction {
    type: typeof COMPLETE_PROFILE;
    payload: CreateUserProfileDto;
}

export interface AcceptInvitationAction {
    type: typeof ACCEPT_INVITATION;
    payload: AccetpInvitationDto;
}

export type InvitationActionTypes =
    | LoadCurrentInvitationAction
    | CompletetProfileAction
    | AcceptInvitationAction;
